import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';
import './MarkdownContent.scss';

const sanitizeSchema = {
    ...defaultSchema,
    attributes: {
        ...defaultSchema.attributes,
        code: [...(defaultSchema.attributes?.code || []), ['className']],
        img: [
            ...(defaultSchema.attributes?.img || []),
            ['src', 'alt', 'title'],
        ],
        a: [...(defaultSchema.attributes?.a || []), ['href', 'title', 'target', 'rel']],
    },
    tagNames: [
        ...(defaultSchema.tagNames || []),
        'h1',
        'h2',
        'h3',
        'h4',
        'pre',
        'code',
        'table',
        'thead',
        'tbody',
        'tr',
        'th',
        'td',
    ],
};

function safeUrlTransform(url) {
    const s = String(url || '').trim();
    if (s.startsWith('https://')) return s;
    if (s.startsWith('/') && !s.startsWith('//')) return s;
    return '';
}

export function MarkdownContent({ children, className }) {
    if (!children) return null;

    return (
        <div className={className ? `markdown-content ${className}` : 'markdown-content'}>
            <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[[rehypeSanitize, sanitizeSchema]]}
                urlTransform={safeUrlTransform}
                components={{
                    a: ({ href, children: linkChildren, ...props }) => (
                        <a
                            href={href}
                            target="_blank"
                            rel="noopener noreferrer"
                            {...props}
                        >
                            {linkChildren}
                        </a>
                    ),
                    img: ({ src, alt, ...props }) =>
                        src ? <img src={src} alt={alt || ''} {...props} /> : null,
                }}
            >
                {String(children)}
            </ReactMarkdown>
        </div>
    );
}

export default MarkdownContent;
